export const redirectToUrl = url => {
    window.location = url;
};
